import script from "./AiCoverLetterPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./AiCoverLetterPreview.vue?vue&type=script&setup=true&lang=js"

import "./AiCoverLetterPreview.vue?vue&type=style&index=0&id=50a8f4be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a8f4be"]])

export default __exports__